"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable no-nested-ternary */

/* eslint-disable eqeqeq */


// href：按钮链接
// txt：按钮内容
// href:跳转链接
// onCallback：点击事件
// colType：颜色类型 transparent,ash：无底色 blue：蓝色 white：白色 text:文字 text-icon：文字+图标
// sizeType：尺寸类型 large：大 in:中 Small：小
// alignType:对齐方式 left:左 center:居中 右：right
// tintType:背景主题 false：深色 true:浅色
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var txt = props.txt,
      colType = props.colType,
      sizeType = props.sizeType,
      alignType = props.alignType,
      tintType = props.tintType,
      href = props.href,
      onCallback = props.onCallback,
      className = props.className,
      styles = props.styles,
      colorTheme = props.colorTheme,
      extendProps = props.extendProps,
      restProps = __rest(props, ["txt", "colType", "sizeType", "alignType", "tintType", "href", "onCallback", "className", "styles", "colorTheme", "extendProps"]); // 初始值设置为不是移动端


  var _a = (0, _react.useState)(false),
      isMobile = _a[0],
      setIsMobile = _a[1];

  var fixFunc = (0, _utils.throttle)(function () {
    var wi_w = document.documentElement.offsetWidth || document.body.offsetWidth;
    window.removeEventListener('resize', fixFunc, false);

    if (wi_w <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, 50);
  (0, _react.useEffect)(function () {
    fixFunc();
    window.addEventListener('resize', fixFunc);
    return function () {
      window.removeEventListener('resize', fixFunc);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: (0, _classnames["default"])('tci-button', {
      left: alignType === 'left',
      center: alignType === 'center',
      right: alignType === 'right',
      dark: !tintType
    })
  }), href ? /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    target: isMobile ? '_self' : '_blank',
    rel: "noreferrer",
    style: styles || {}
  }, /*#__PURE__*/_react["default"].createElement("button", __assign({
    type: "button",
    className: (0, _classnames["default"])('but', {
      transparent: colType === 'ash' || colType === 'transparent',
      blue: colType === 'blue',
      white: colType === 'white',
      textIcon: colType === 'text-icon',
      large: sizeType === 'large',
      "in": sizeType === 'in' || sizeType === 'middle',
      Small: sizeType === 'Small' || sizeType === 'small'
    }),
    style: styles || {},
    onClick: function onClick() {
      onCallback && onCallback(txt);
    }
  }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('txtwrap', {
      lighthousecolor: colorTheme == 'gradient'
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "txtwrap-span"
  }, txt), colType == 'text-icon' ? colorTheme == 'gradient' ? /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.48679L13.5887 6L20 12L13.5887 18L12 16.5132L15.8921 13H5V11H15.8921L12 7.48679Z",
    fill: "#01B457"
  })) : /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.48679L13.5887 6L20 12L13.5887 18L12 16.5132L15.8921 13H5V11H15.8921L12 7.48679Z",
    fill: "#006EFF"
  })) : null))) : /*#__PURE__*/_react["default"].createElement("button", __assign({
    type: "button",
    className: (0, _classnames["default"])('but', {
      transparent: colType === 'ash' || colType === 'transparent',
      blue: colType === 'blue',
      white: colType === 'white',
      large: sizeType === 'large',
      "in": sizeType === 'in' || sizeType === 'middle',
      Small: sizeType === 'Small' || sizeType === 'small'
    }),
    style: styles || {},
    onClick: function onClick() {
      onCallback && onCallback(txt);
    }
  }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('txtwrap', {
      lighthousecolor: colorTheme == 'gradient'
    })
  }, txt, colType == 'text-icon' ? colorTheme == 'gradient' ?
  /*#__PURE__*/
  // <IconFont name="Enter" /> 使用IconFont测试环境无法显示
  _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.48679L13.5887 6L20 12L13.5887 18L12 16.5132L15.8921 13H5V11H15.8921L12 7.48679Z",
    fill: "#01B457"
  })) : /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.48679L13.5887 6L20 12L13.5887 18L12 16.5132L15.8921 13H5V11H15.8921L12 7.48679Z",
    fill: "#006EFF"
  })) : null)));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;